const allowedToPublish = ["ROLE_SUP_ADMIN","ROLE_ADMIN_COMMUNITY", "ROLE_ANIMATOR", "ROLE_EDITOR"];

const allowedToSubscribe = ["ROLE_SUP_ADMIN", "ROLE_USER", "ROLE_SPONSOR_DIGITAL","ROLE_ADMIN_COMMUNITY", "ROLE_ANIMATOR", "ROLE_EDITOR"];

const allowedToOrderService = ["ROLE_SUP_ADMIN", "ROLE_USER"];

export {allowedToPublish, allowedToSubscribe, allowedToOrderService};
